export const getTokens = async (
  distributionContract,
  id,
  proof,
  recipientAddress,
  amount
) => {
  const trx = await distributionContract.getTokens(
    id,
    proof,
    recipientAddress,
    amount
  );

  return await trx.wait();
};

export const getTokensFromMultiple = async (
  distributionContract,
  ids,
  proofs,
  recipientAddress,
  amounts
) => {
  const trx = await distributionContract.getTokensFromMultiple(
    ids,
    proofs,
    recipientAddress,
    amounts
  );

  return await trx.wait();
};

export const spentERC20 = async (
  distributionContract,
  id,
  recipientAddress
) => {
  return await distributionContract.checkCollected(id, recipientAddress);
};
